import { render, staticRenderFns } from "./ModalTablePaginationServer.vue?vue&type=template&id=8266d99a&"
import script from "./ModalTablePaginationServer.vue?vue&type=script&lang=js&"
export * from "./ModalTablePaginationServer.vue?vue&type=script&lang=js&"
import style0 from "./ModalTablePaginationServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports